import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateProfile } from '../api/profileApi';
import type { ServiceProviderProfile, UpdateProfileData } from '../api/profileApi';

export function useUpdateProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateProfileData) => updateProfile(data),
    onSuccess: (updatedProfile: ServiceProviderProfile) => {
      queryClient.invalidateQueries({ queryKey: ['provider', 'profile'] });
      queryClient.setQueryData<ServiceProviderProfile>(['provider', 'profile'], updatedProfile);
    },
  });
}
